$(document).ready(function () {
  // Safety check: only initialize if carousel elements exist
  const $carousel = $(
    '.owl-carousel, .content-split__images--carousel, .hero-block__images--carousel'
  );

  if ($carousel.length > 0) {
    // Prevent CLS by setting explicit height before initialization
    $carousel.each(function () {
      const $this = $(this);

      // Only process if it hasn't been initialized yet
      if ($this.hasClass('slick-initialized')) return;

      const firstImage = $this.find('img').first();

      if (firstImage.length) {
        // Set min-height based on image dimensions or natural height
        if (firstImage[0].complete && firstImage[0].naturalHeight > 0) {
          const height = firstImage.height();
          if (height > 0) {
            $this.css('min-height', height + 'px');
          }
        } else {
          // Image not loaded yet, wait for it
          firstImage.on('load', function () {
            const height = $(this).height();
            if (height > 0) {
              $this.css('min-height', height + 'px');
            }
          });
        }
      }
    });

    // Small delay to ensure images are processed
    setTimeout(() => {
      $carousel.not('.slick-initialized').slick({
        slidesToShow: 1,
        vertical: false,
        arrows: true,
        dots: false,
        autoplay: true,
        adaptiveHeight: false, // Changed to false to prevent CLS
        fade: false,
        cssEase: 'ease-out',
        speed: 300,
        waitForAnimate: true,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none" aria-hidden="true"><path d="M20 10.1117L18.225 11.8867L10 3.66172L1.775 11.8867L0 10.1117L10 0.111718L20 10.1117Z" fill="#151820"/></svg></button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none" aria-hidden="true"><path d="M20 1.88828L18.225 0.113281L10 8.33828L1.775 0.113281L0 1.88828L10 11.8883L20 1.88828Z" fill="#151820"/></svg></button>',
      });
    }, 50);
  }
});
